<template>
  <v-menu>
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        prepend-icon="business"
        :title="currentCompanyName"
        subtitle="Podjetje"
        append-icon="arrow_drop_down"
        data-cy="company-switch"
      />
    </template>

    <v-list>
      <v-list-item
        v-for="company in companies"
        :key="company.value"
        :title="company.title"
        :active="company.value === currentCompanyId"
        color="primary"
        @click="switchCompany(company.value)"
      />
    </v-list>
  </v-menu>
</template>

<script>
  import router from '../../router';

  export default {
    name: 'CompanySwitch',
    data() {
      return {
        companies: this.$store.getters.companies.map(c => {
            return {
              title: c.name,
              value: c.company_id
            };
        })
      };
    },
    computed: {
      currentCompanyId() {
        return this.$store.getters.currentCompany.company_id;
      },
      currentCompanyName() {
        return this.companies.find(company => company.value === this.currentCompanyId)?.title;
      },
    },
    methods: {
      async switchCompany(companyId) {
        await this.$store.dispatch('switchCompany', companyId);
        router.push('/');
      }
    }
  }
</script>
